export const RESPONSE_STATUS = {
  SUCCESS: 200,
  SUCCESS_NO_CONTENT: 204,
  NOT_FOUND: 404
};
